export default {

  LANGUAGE: 'PT',

  ORDER: 4,

  HEARING_TEST: {

    INSTRUCTIONS_DECIBEIS: -20,

    INSTRUMENTS_DECIBEIS: [-30, -40, -50],

    NUMBERS_DECIBEIS: 0,

    NUMBERS_NOISE_DECIBEIS: [-100, -80, -60, -40, -20, 0],

    TEST_DECIBEIS: [-55, -45, -35, -25, -15, -5, 0],

    MIN_LOSS_INTERVAL: 10,

    BEEP_DURATION: 3000,

    BEEP_INTERVAL: 1000
  },

  QUESTIONNAIRE: {
    EN: {
      ID: 18,
      MIN_LOSS_VALUE: 90
    },
    PT: {
      ID: 17,
      MIN_LOSS_VALUE: 90
    },
  },

  LEAD: {

    ENTITY_ID: 1,

    SOURCE_ID: 7
    
  }
}